// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Quote: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M36,0H4C1.8,0,0,1.8,0,4v36l8-8h28c2.2,0,4-1.8,4-4V4C40,1.8,38.2,0,36,0z
	 M21.79,23.93v2.42h-3.38V23.9c-2.17-0.46-4.02-1.85-4.15-4.32h2.48c0.12,1.33,1.04,2.37,3.36,2.37c2.49,0,3.05-1.24,3.05-2.02
	c0-1.05-0.56-2.04-3.38-2.72c-3.15-0.76-5.3-2.05-5.3-4.66c0-2.18,1.76-3.6,3.95-4.07V6.05h3.38v2.47c2.36,0.58,3.54,2.36,3.62,4.3
	h-2.49c-0.07-1.41-0.81-2.37-2.82-2.37c-1.91,0-3.04,0.86-3.04,2.09c0,1.07,0.82,1.76,3.38,2.42c2.56,0.67,5.3,1.76,5.3,4.96
	C25.74,22.23,23.99,23.51,21.79,23.93z"/>
</svg>;
};

export default React.memo(Quote);
